import styled from 'styled-components';
import {opacity} from '../../theme/theme'


const BannerContainer = styled.div`
    animation: ${opacity} 3s ease;
    img {
        max-height: 365px;
        object-fit: cover;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){
        img {
            max-height: 165px;
    }
    } 
`

const ShadowLeft = styled.div`
        width: 40px;
        height: 70px;
        background-color:#000;
        opacity:0.4;
        position: absolute;
        top: calc(50% - 28px);
        border-bottom: 4px solid;
        border-left:4px solid;
        left: 29px;
        z-index:9000;
        @media (max-width: 600px){
            top: calc(50% - 25px);
            left: 14px;
            width: 22px;
            height: 40px;
            background-color:#000;
        };
        &:before {
            content: '';
        }
`
const ShadowRight = styled.div`
        width: 40px;
        height: 70px;
        background-color:#000;
        opacity:0.4;
        position: absolute;
        top: calc(50% - 28px);
        border-bottom: 4px solid;
        border-left:4px solid;
        right:30px;
        z-index:9000;
        @media (max-width: 600px){
            top: calc(50% - 25px);
            right: 14px;
            width: 22px;
            height: 40px;
            background-color:#000;
        };
        &:before {
            content: '';
        }
`


const StylePrev = styled.div`
        width: 40px;
        height: 40px;
        position: absolute;
        top: calc(50% - 15px);
        border-bottom: 4px solid;
        border-left:4px solid;
        transform: rotate(45deg);
        left: 40px;
        z-index:10000;
        cursor: pointer;
        border-color: #A8A8A8;
        @media (max-width: 600px){
            left: 20px;
            width: 20px;
            height: 20px;
            border-bottom: 2px solid;
            border-left:2px solid;
            border-color:#A8A8A8;
        };
        &:before {
            content: '';
        }
`

const StyleNext = styled.div`
        width: 40px;
        height: 40px;
        border-color: #FFF;
        position: absolute;
        top: calc(50% - 15px);
        border-bottom: 4px solid;
        border-left:4px solid;
        transform: rotate(-135deg);
        right: 40px;
        z-index:10000;
        cursor: pointer;
        border-color: #A8A8A8;
        @media (max-width: 600px){
            right: 20px;
            width: 20px;
            height: 20px;
            border-bottom: 2px solid;
            border-left:2px solid;
            border-color:#A8A8A8;
        }; 
        &:before {
            content: '';
        }
`



export {StylePrev, StyleNext, BannerContainer, ShadowRight, ShadowLeft}